import * as React from "react"

const LeftChevron = (props) => (
  <svg
    width={8}
    height={14}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Shape</title>
    <defs>
      <path id="a" d="M12 2.633 10.486 1 4 8l6.486 7L12 13.367 7.027 8z" />
    </defs>
    <use
      xlinkHref="#a"
      fillRule="evenodd"
      transform="translate(-4 -1)"
    />
  </svg>
)
export default LeftChevron
